module.exports = __webpack_public_path__ + "static/media/li.64c4108b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/li.svg
// module id = 875
// module chunks = 0